import { ToastError, ToastInfo, ToastSuccess } from "components/Global/Toasts/Toasty";
import { put, takeLatest } from "redux-saga/effects";
import { defaultReturn, generateDefaultActions, makePayload, makeWritePayload, requestSaga } from "shared-utility/store/utils/helpers";

// ACTIONS

export const GET_FIELDS = generateDefaultActions("GET_FIELDS");
export const getFields = payload => makePayload(GET_FIELDS.value, payload);
function* getFieldsSaga({ dealId }) {
  const url = `/fields/deal/${dealId}`;
  yield requestSaga(GET_FIELDS, url, "GET", null, null, null, true);
}

export const POST_FIELD = generateDefaultActions("POST_FIELD");
export const postFieldConfig = payload => makePayload(POST_FIELD.value, payload);
function* postFieldConfigSaga({ data }) {
  const url = "/fields";
  yield requestSaga(POST_FIELD, url, "POST", data, null, null, true);
}

export const SET_FIELD_UPDATED_FLAG = generateDefaultActions("SET_FIELD_UPDATED_FLAG");
export const PUT_FIELD = generateDefaultActions("PUT_FIELD");
export const putFieldConfig = payload => makePayload(PUT_FIELD.value, payload);
function* putFieldConfigSaga({ data }) {
  const url = "/fields";
  yield requestSaga(PUT_FIELD, url, "PUT", data, null, null, true);
  yield put(SET_FIELD_UPDATED_FLAG.createSuccess(true));
}

export const DELETE_FIELD = generateDefaultActions("DELETE_FIELD");
export const deleteFieldConfig = payload => makePayload(DELETE_FIELD.value, payload);
function* deleteFieldConfigSaga({ fieldId }) {
  const url = `/fields/${fieldId}`;
  yield requestSaga(DELETE_FIELD, url, "DELETE", null, null, null, true);
  yield put(SET_FIELD_UPDATED_FLAG.createSuccess(true));
}

export const DELETE_FIELDS = generateDefaultActions("DELETE_FIELDS");
export const deleteFieldsConfig = payload => makePayload(DELETE_FIELDS.value, payload);
function* deleteFieldsConfigSaga({ dealId, fieldIds }) {
  const url = `/fields/deal/${dealId}`;
  yield requestSaga(DELETE_FIELDS, url, "DELETE", fieldIds, null, null, true);
}

export const GET_NOI_VALUES_PER_GROUP = generateDefaultActions("GET_NOI_VALUES_PER_GROUP");
export const getNoiValuesPerGroup = payload => makePayload(GET_NOI_VALUES_PER_GROUP.value, payload);
function* getNoiValuesPerGroupSaga({ dealId }) {
  const url = `/fields/noiValuesPerGroup/${dealId}`;
  yield requestSaga(GET_NOI_VALUES_PER_GROUP, url, "GET", null, null, null, true);
}

export const SET_FIELD_SELECTIONS = generateDefaultActions("SET_FIELD_SELECTIONS");
export const setFieldSelections = payload => makeWritePayload(SET_FIELD_SELECTIONS.value, payload);

export const actionCreators = {
  getFields,
  postFieldConfig,
  putFieldConfig,
  setFieldSelections,
  deleteFieldConfig,
  deleteFieldsConfig,
  getNoiValuesPerGroup
};

// REDUCER
const initialState = {
  currentSelectedFieldType: null,
  fields: null,
  fieldsFilter: "0",
  isAdding: false,
  isEditing: false,
  isLoading: false,
  isSelectingField: false,
  selectedField: null,
  isFromDscrFromFile: false,
  isFromAddNewLineItem: false,
  isFromDebtYieldCalculation: false,
  deleteDialogOpen: false,
  fieldIdToDelete: null,
  fieldToDelete: null,
  fieldDeleted: false,
  noiValuesPerReportGroup: null
};

export function lenderReportFieldManagementReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FIELDS.failure:
      ToastError("Failed to fetch existing fields.");

      return defaultReturn({ ...state, isLoading: false }, null, "fields");
    case GET_FIELDS.success:
      if (payload.data && !payload.data.length) {
        ToastInfo("There are no existing fields.");
      }

      return defaultReturn({ ...state, isLoading: false }, payload.data, "fields");
    case GET_FIELDS.value:
      return defaultReturn({ ...state, isLoading: true }, null, "fields");

    case POST_FIELD.success:
      ToastSuccess("Field saved successfully");

      return defaultReturn({ ...state, isLoading: false, isAdding: false, fields: null });
    case POST_FIELD.failure:
      ToastError("Failed to save field");

      return defaultReturn({ ...state, isLoading: false });
    case POST_FIELD.value:
      return defaultReturn({ ...state, isLoading: true });

    case PUT_FIELD.success:
      ToastSuccess("Field saved successfully");

      return defaultReturn({ ...state, isLoading: false, isEditing: false, fields: null, selectedField: null });
    case PUT_FIELD.failure:
      ToastError("Failed to save field");

      return defaultReturn({ ...state, isLoading: false });
    case PUT_FIELD.value:
      return defaultReturn({ ...state, isLoading: true });

    case DELETE_FIELD.success: {
      const deletedFieldsIds = payload.data.deletedFieldIds;
      const filteredFields = state.fields && state.fields.filter(f => !deletedFieldsIds.includes(f.id));

      return defaultReturn({ ...state, fields: filteredFields || null, fieldIdToDelete: null, deleteDialogOpen: false, fieldDeleted: true });
    }
    case DELETE_FIELD.failure:
      ToastError("Failed to delete field");

      return defaultReturn({ ...state });
    case DELETE_FIELD.value:
      return defaultReturn({ ...state });

    case DELETE_FIELDS.success: {
      ToastSuccess("Fields deleted successfully");
      return defaultReturn({ ...state, fields: null });
    }
    case DELETE_FIELDS.failure:
      ToastError("Failed to delete fields");

      return defaultReturn({ ...state });
    case DELETE_FIELDS.value:
      return defaultReturn({ ...state });

    case GET_NOI_VALUES_PER_GROUP.success:
      return defaultReturn({ ...state, noiValuesPerReportGroup: payload.data });

    case GET_NOI_VALUES_PER_GROUP.value:
      return defaultReturn({ ...state });

    case GET_NOI_VALUES_PER_GROUP.failure:
      return defaultReturn({ ...state, noiValuesPerReportGroup: null });

    case SET_FIELD_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    default:
      return state;
  }
}

// SAGA
export function* lenderReportFieldManagementSaga() {
  yield takeLatest(GET_FIELDS.value, getFieldsSaga);
  yield takeLatest(POST_FIELD.value, postFieldConfigSaga);
  yield takeLatest(PUT_FIELD.value, putFieldConfigSaga);
  yield takeLatest(DELETE_FIELD.value, deleteFieldConfigSaga);
  yield takeLatest(DELETE_FIELDS.value, deleteFieldsConfigSaga);
  yield takeLatest(GET_NOI_VALUES_PER_GROUP.value, getNoiValuesPerGroupSaga);
}
